module.exports = __webpack_public_path__ + "img/filter-icon.bb7623f9.svg";